import { connect } from 'react-redux';
import SearchMap from './SearchMap';

const mapStateToProps = ({ global, searchCars }) => ({
  listPlaces: global.listPlaces,
  params: searchCars.params,
});

export default connect(mapStateToProps, null)(SearchMap);
